var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-chart"},[_c('header',[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._v(_vm._s(_vm.subTitle))])]),_c('div',{ref:"target",staticStyle:{"width":"100%"},style:({ height: _vm.height })})])
}
var staticRenderFns = []

export { render, staticRenderFns }